// extracted by mini-css-extract-plugin
module.exports = {"root":"Column_root__nwGIq","list":"Column_list__1Elj_","add":"Column_add__2yml1"};